//recent issues matching Object 
export const  issueMatchingObj = {
    1: 'Deep discharge',
    2: 'Overheating',
    3: 'Unknown anomaly',
    4: 'Missing data'
}

// connectionStatusId Matching Object
export const conIdMatchingObj = {
    1: 'Online',
    2: 'Pending',
    3: 'Offline'
}